// hooks/codes/useCodeDeletion.js

import { useState, useCallback } from 'react';
import { useDeleteCode } from './mutations/useDeleteCode';

const useCodeDeletion = (projectId) => {
  const [deleteCode, setDeleteCode] = useState({});
  const deleteCodeMutation = useDeleteCode();

  const deleteCodeHandler = useCallback((code) => {
    setDeleteCode(code);
  }, []);

  const cancelDelete = useCallback(() => {
    setDeleteCode({});
  }, []);

  const confirmDelete = useCallback(() => {
    if (deleteCode.id && projectId) {
      deleteCodeMutation.mutate({ 
        codeId: deleteCode.id,
        projectId: projectId
      });
    }
    setDeleteCode({});
  }, [deleteCode.id, projectId, deleteCodeMutation]);

  return {
    deleteCode,
    deleteCodeHandler,
    cancelDelete,
    confirmDelete,
    isDeleteModalOpen: !!deleteCode.id,
    isDeleting: deleteCodeMutation.isPending
  };
};

export default useCodeDeletion;